import { useKeycloak } from "@react-keycloak/web";
import { useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import MaterialModal from "../../app/material-modal";
import { Box, Button, Stack, Typography, CircularProgress } from "@mui/material";
import { useMakeAdministrator } from "../../../tanstackQuery/queries/superAdmin/roles";

export const MakeAdministratorModal = ({ open, handleClose, singleUserData,orgID }) => {
    const { keycloak }  = useKeycloak();
    const client = useQueryClient();
  
    const { mutateAsync: createOrgAdmin,isPending,isSuccess} = 
       useMakeAdministrator(
        { accessToken: keycloak?.token },
        {
          onSuccess:()=>{
            client.invalidateQueries({ queryKey: ["orgUserList"] });
            handleClose();
          }
        }
       );
  
    const addAdministratorRole =async ()=>{
       const payload = {
         userID: singleUserData.userID,
         orgID
       }
       try {
          await createOrgAdmin(payload);
          if (isSuccess) {
            toast.success("Administrator role added successfully!");
          }
        } catch (error) {
          toast.error(error?.response?.data?.payload?.message || "Failed to add administrator role.");
        }
    }
  
    return (
      <MaterialModal
        title="Are you sure?"
        open={open}
        onClose={handleClose}
        handleDialogClose={handleClose}
        styleOverrides={{
          container: {
            "& .MuiDialog-paper": {
              width: "100%",
              minWidth: "300px",
              minHeight: "200px",
            },
          },
        }}
      >
        <Box>
          <Typography variant="subtitle1">
            Do you want to give{" "}
            <span style={{ fontWeight: "bold" }}>"{singleUserData.name}"</span>{" "}
            organization admin privileges?
          </Typography>

          <Stack direction="row" justifyContent="flex-end" gap={1} mt={2}>
            <Button variant="outlined" onClick={handleClose}>
              No
            </Button>
            <Button
              disabled={isPending}
              variant="contained"
              onClick={() => addAdministratorRole()}
              endIcon={isPending ? <CircularProgress size={15} color="primary" />:null}
            >
              Yes
            </Button>
          </Stack>
        </Box>
      </MaterialModal>
    );
  };